import {
  AccountAttempt,
  PostUsersMeProvidersAwsSubAccountsByAccountIdApiResponse,
  ProviderAccessType,
} from "../../../../../services/cloudchipr.api";
import { AccountsGroupedByProvider } from "../../../../accounts/utils/types/types";

interface ConvertSubAccountRoleResponseToAccountAttemptArgs {
  accounts: AccountsGroupedByProvider;
  subAccountRole: PostUsersMeProvidersAwsSubAccountsByAccountIdApiResponse;
  accessType: ProviderAccessType;
  accountId: string;
}
export const convertSubAccountRoleResponseToAccountAttempt = ({
  accounts,
  subAccountRole,
  accountId,
  accessType,
}: ConvertSubAccountRoleResponseToAccountAttemptArgs):
  | AccountAttempt
  | undefined => {
  const account = accounts?.["aws"]?.find((item) => item.id === accountId);
  if (!account) {
    return;
  }
  return {
    id: accountId,
    type: "aws",
    access_type: accessType,
    user_id: account.user_id,
    status: "started",
    status_details: {
      started: {
        cli_command: subAccountRole.cli_command ?? "",
        console_link: subAccountRole.console_link ?? "",
        terraform: "",
      },
    },
    account_id: accountId,
    created_at: account.created_at,
  };
};
